import React, { useState } from 'react'
import { Dropdown, Button, DynamicIcon, Checkbox } from 'legion-ui'
import './style.scss'
const ExampleFive = () => {
  const [isOpen, setOpen] = useState(false)
  const toogle = () => setOpen(prev => !prev)
  const onClose = () => setOpen(false)
  const clearSelected = () => setSelecdtedData([])

  const categories = ['Automative', 'Electronics', 'Fashion', 'Furniture', 'Sport & Travel']
  const provinces = ['Jawa', 'Kalimantan', 'Sumatera', 'Aceh', 'Papua']
  const [selectedData, setSelecdtedData] = useState([])
  const isChecked = (value) => selectedData.includes(value)
  const selectProvince = (e) => setSelecdtedData([...selectedData, e.target.value])

  return (
    <Dropdown 
      trigger={<Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>Filter</Button>}
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position='center'
    >
      <div className="example-row">
        <div className="example-half">
          <div className="example-body">
            <h3 className="example-title">Category</h3>
            {categories.map( category => 
              <Checkbox key={category} value={category} label={category} onChange={selectProvince} checked={isChecked(category)}/>
            )}
          </div>
        </div>
        <div className="example-half">
            <div className="example-body">
              <h3 className="example-title">Region</h3>
              {provinces.map( province => 
                <Checkbox key={province} value={province} label={province} onChange={selectProvince} checked={isChecked(province)}/>
              )}
            </div>
        </div>
      </div>
      <div className="example-footer-button">
        <Button variant='outline' onClick={clearSelected}>Clear</Button>
        <Button style={{marginLeft: '10px'}} onClick={onClose}>Submit</Button>
      </div>
    </Dropdown>
  )
}

export default ExampleFive